// Store custom user auth data

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, USER_TYPES, AUTH_USER_STATUSES, CONTACT_POINT_SYSTEM } = require('@bcm/constants');
const { AuthTableBase } = require('./base.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  sub: Joi.string().required(),
  password: Joi.string().required(),
  accountStatus: Joi.boolean().required(),
  confirmationStatus: Joi.string().valid( ...Object.keys(AUTH_USER_STATUSES) ).required(),
  username: Joi.string().required(),
  firstName: Joi.string().required(),
  lastName: Joi.string().required(),
  uuid: Joi.string().required(),
  contact: Joi.string().required(),
  contactType: Joi.string().valid( ...Object.keys(CONTACT_POINT_SYSTEM) ).required(),
  orgId: Joi.string().optional(),
  groups: Joi.array().items( Joi.string().valid( ...Object.keys(USER_TYPES) ).required() ).optional(),
  expiresAt: Joi.string().optional(),
  snsTopicArn: Joi.string().optional(),
};

// Define class
class AuthUser extends AuthTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super(
      identifiers.authUser.buildPk(),
      identifiers.authUser.buildSk(obj.state, obj.contact),
      identifiers.authUser.buildGsiPk(),
      identifiers.authUser.buildGsiSk(obj.state, obj.username),
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.AuthUser = AuthUser;
exports.authUserSchema = schema;
